'use strict';

var index = require('../color/index.cjs');
var filter = require('../complex/filter.cjs');
var number = require('./number.cjs');

/**
 * A map of default value types for common values
 */
const defaultValueTypes = {
    ...number.numberValueTypes,
    // Color props
    color: index.color,
    backgroundColor: index.color,
    outlineColor: index.color,
    fill: index.color,
    stroke: index.color,
    // Border props
    borderColor: index.color,
    borderTopColor: index.color,
    borderRightColor: index.color,
    borderBottomColor: index.color,
    borderLeftColor: index.color,
    filter: filter.filter,
    WebkitFilter: filter.filter,
};
/**
 * Gets the default ValueType for the provided value key
 */
const getDefaultValueType = (key) => defaultValueTypes[key];

exports.defaultValueTypes = defaultValueTypes;
exports.getDefaultValueType = getDefaultValueType;
//# sourceMappingURL=defaults.cjs.map
